import React, { useState } from "react";
import { useFormikContext } from "formik";
import { TabPanel, TabView } from "primereact/tabview";
import { Badge, Card } from "react-bootstrap";
import { Editor } from "primereact/editor";
import {
  FormDateField,
  FormSelectField,
  FormTextField,
} from "../../../../../partials/content/Forms/FormField";
import QuotationAddress from "./quotationAddress";
import QuotationContact from "./quotationContact";
import QuotationTOC from "./quotationTOC";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import SearchCurrency from "../../../setup/finance/searchCurrency";
import { DialogActions } from "@material-ui/core";
import SearchCustomer from "../../customers/searchCustomer";
import SearchLead from "../../../crm/leads/searchLead";
import SearchUser from "../../../users/users/searchUser";
import { amountByPercent, percentByAmount } from "../../../../../utils/utils";
import SearchGlAccount from "../../../setup/finance/searchGlAccount";

function QuotationHeader({
  customerAddresses,
  onSetCustomerAddresses,
  customerContacts,
  onSetCustomerContacts,
  onChangeCustomer,
  quotationTOCs,
  onSetQuotationTOCs,
}) {
  const { values, setFieldValue } = useFormikContext();
  const [openSearchCashAccount, setOpenSearchCashAccount] = useState(false);
  const [openSearchCurrency, setOpenSearchCurrency] = useState(false);
  const [openSearchCustomer, setOpenSearchCustomer] = useState(false);
  const [openSearchLead, setOpenSearchLead] = useState(false);
  const [openSearchSales, setOpenSearchSales] = useState(false);
  const [customerAddressDefault, setCustomerAddressDefault] = useState(false);
  const [customerContactDefault, setCustomerContactDefault] = useState(false);
  const [customerTOCDefault, setCustomerTOCDefault] = useState(false);

  return (
    <React.Fragment>
      <div className="tabview mb-3">
        <div className="card">
          <TabView renderActiveOnly={false} className="tabview" scrollable>
            <TabPanel header="Quotation Main" rightIcon="fas fa-th-large">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-window-maximize"></i>
                      <span>
                        <strong>Quotation Header</strong>
                      </span>
                      {values.quotationCode !== "" ? (
                        <Badge
                          className="float-right ml-1"
                          variant={
                            values.salesStatus === 4
                              ? "danger"
                              : values.salesStatus === 1
                              ? "warning"
                              : values.salesStatus === 3
                              ? "success"
                              : null
                          }
                        >
                          {values.salesStatus !== 0
                            ? "Quote " + values.salesStatusDesc
                            : null}
                        </Badge>
                      ) : null}
                      <Badge className="float-right ml-1" variant="info">
                        {`Version ${values.ver}`}
                      </Badge>
                    </Card.Header>
                    <Card.Body>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          {values.quotationCode !== "" ? (
                            <FormTextField
                              label="Quotation ID"
                              name="quotationCode"
                              readonly
                            />
                          ) : null}
                          {values.ID === 0 ? (
                            <React.Fragment>
                              {(values.ticketID > 0 &&
                                values.salesCardID > 0) ||
                              (values.ticketID === 0 &&
                                values.salesCardID === 0) ? (
                                <FormSelectField
                                  label="Type"
                                  name="customerType"
                                  onSelectChange={(value) => {
                                    handleChangeCustomerType();
                                  }}
                                  options={[
                                    { label: "Lead", value: 1 },
                                    { label: "Customer", value: 2 },
                                  ]}
                                />
                              ) : null}
                              {values.customerType === 2 ? (
                                <FormTextField
                                  label="Customer Name"
                                  name="customerName"
                                  searchButton={
                                    values.ticketID === 0 &&
                                    values.salesCardID === 0
                                      ? true
                                      : false
                                  }
                                  readonly
                                  onSearchClick={() => {
                                    setOpenSearchCustomer(true);
                                  }}
                                />
                              ) : (
                                <FormTextField
                                  label="Lead Name"
                                  name="leadName"
                                  searchButton={
                                    values.ticketID === 0 &&
                                    values.salesCardID === 0
                                      ? true
                                      : false
                                  }
                                  readonly
                                  onSearchClick={() => {
                                    setOpenSearchLead(true);
                                  }}
                                />
                              )}
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <FormTextField
                                label={
                                  values.customerType === 2
                                    ? "Customer Name"
                                    : "Lead Name"
                                }
                                name="customerName"
                                searchButton={
                                  values.ticketID === 0 &&
                                  values.salesCardID === 0
                                    ? true
                                    : false
                                }
                                readonly
                                onSearchClick={() => {
                                  setOpenSearchCustomer(true);
                                }}
                              />
                            </React.Fragment>
                          )}
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormTextField
                                label="Currency"
                                name="currencyCode"
                                searchButton
                                readonly
                                onSearchClick={() => {
                                  setOpenSearchCurrency(true);
                                }}
                              />
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormTextField
                                label="Exchange Rate To Base Currency"
                                name="exchangeRate"
                                currencyField
                                fullDecimals={true}
                                readonly
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormDateField
                                label="Quotation Date"
                                name="quotationDate"
                              />
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormDateField
                                label="Expiry Date"
                                name="expiryDate"
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormTextField
                                label="Sales Agent"
                                name="salesName"
                                searchButton
                                readonly
                                onSearchClick={() => {
                                  setOpenSearchSales(true);
                                }}
                              />
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormTextField
                                label="Customer RFQ Number"
                                name="customerRfqNo"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </TabPanel>
            <TabPanel
              header={`Address & Contact`}
              rightIcon="fas fa-map-marked-alt"
            >
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6 mb-3 mb-md-0">
                  <QuotationAddress
                    customerAddresses={customerAddresses}
                    customerAddressDefault={customerAddressDefault}
                    handleCustomerAddressDefault={handleCustomerAddressDefault}
                  />
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <QuotationContact
                    customerContacts={customerContacts}
                    customerContactDefault={customerContactDefault}
                    handleCustomerContactDefault={handleCustomerContactDefault}
                  />
                </div>
              </div>
            </TabPanel>
            <TabPanel
              header={`Note, Terms & Conditions`}
              rightIcon="fas fa-sticky-note"
            >
              <div className="row mb-3">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-sticky-note"></i>
                      <span>
                        <strong>Note</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <Editor
                        style={{ height: "200px", width: "100%" }}
                        onTextChange={(e) => {
                          setFieldValue("note", e.htmlValue);
                        }}
                        value={values.note}
                        placeholder="Type your notes here..."
                      />
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <QuotationTOC
                    quotationTOCs={quotationTOCs}
                    customerTOCDefault={customerTOCDefault}
                    handleCustomerTOCDefault={handleCustomerTOCDefault}
                  />
                </div>
              </div>
            </TabPanel>
            <TabPanel
              header="DP Invoice"
              rightIcon="fas fa-file-invoice-dollar"
            >
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-money-bill-wave"></i>
                      <span>
                        <strong>Down Payment</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <FormTextField
                            label="Down Payment Percent"
                            name="dpPercent"
                            percentageField
                            onChangeValue={(value) => {
                              calculateDPamount(value, "percent");
                            }}
                          />
                          <FormDateField
                            label="Deadline Date"
                            name="invoiceDeadlineDate"
                          />
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <FormTextField
                            label="Down Payment Amount"
                            name="dpAmount"
                            currencyField
                            onChangeValue={(value) => {
                              calculateDPamount(value, "amount");
                            }}
                          />
                          <FormTextField
                            label="Cash Account"
                            name="cashAccountName"
                            searchButton
                            readonly
                            clearButton
                            onSearchClick={() => {
                              setOpenSearchCashAccount(true);
                            }}
                            clearFields={[
                              { field: "cashAccountID", clearValue: 0 },
                              { field: "cashAccountName", clearValue: "" },
                            ]}
                          />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </TabPanel>
          </TabView>
        </div>
      </div>

      <DialogLayout
        open={openSearchCustomer}
        title="Search Customer"
        onCloseDialog={() => {
          setOpenSearchCustomer(false);
        }}
        maxWIdth="lg"
      >
        <SearchCustomer
          onSelectCustomer={(customer) => {
            setFieldValue("customerID", customer.ID);
            setFieldValue("customerName", customer.customerName);
            setFieldValue("address", customer.address);
            setFieldValue("city", customer.city);
            setFieldValue("province", customer.province);
            setFieldValue("countryCode", customer.countryCode);
            setFieldValue("postalCode", customer.postalCode);
            setFieldValue("addressPhone", customer.addressPhone);
            setFieldValue("addressEmail", customer.addressEmail);
            setFieldValue("contactName", customer.contactName);
            setFieldValue("position", customer.position);
            setFieldValue("contactPhone", customer.contactPhone);
            setFieldValue("contactEmail", customer.contactEmail);
            quotationTOCs.map((quotationTOC, index) => {
              setFieldValue("tocName", quotationTOC);
              setFieldValue("toc", quotationTOC.toc);
              handleCustomerTOCDefault();
            });
            setOpenSearchCustomer(false);
            onChangeCustomer(customer.ID);
            setCustomerAddressDefault(true);
            setCustomerContactDefault(true);
            setCustomerTOCDefault(true);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchCustomer(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchLead}
        title="Search Lead"
        onCloseDialog={() => {
          setOpenSearchLead(false);
        }}
        maxWIdth="lg"
      >
        <SearchLead
          onSelectLead={(lead) => {
            setFieldValue("leadID", lead.ID);
            setFieldValue("leadName", lead.leadName);
            setFieldValue("address", lead.address);
            setFieldValue("city", lead.city);
            setFieldValue("province", lead.province);
            setFieldValue("countryCode", lead.countryCode);
            setFieldValue("postalCode", lead.postalCode);
            setFieldValue("addressPhone", lead.addressPhone);
            setFieldValue("addressEmail", lead.addressEmail);
            setFieldValue("contactName", lead.contactName);
            setFieldValue("position", lead.position);
            setFieldValue("contactPhone", lead.contactPhone);
            setFieldValue("contactEmail", lead.contactEmail);
            quotationTOCs.map((quotationTOC, index) => {
              setFieldValue("tocName", quotationTOC);
              setFieldValue("toc", quotationTOC.toc);
              handleCustomerTOCDefault();
            });
            setCustomerTOCDefault(true);
            setOpenSearchLead(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchLead(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchCurrency}
        title="Search Currency"
        onCloseDialog={() => {
          setOpenSearchCurrency(false);
        }}
        maxWIdth="sm"
      >
        <SearchCurrency
          onSelectCurrency={(currency) => {
            setFieldValue("currencyID", currency.ID);
            setFieldValue("currencyCode", currency.currencyCode);
            setFieldValue("exchangeRate", currency.exRateToBaseCurr);
            setOpenSearchCurrency(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchCurrency(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchSales}
        title="Search Sales Agent"
        onCloseDialog={() => {
          setOpenSearchSales(false);
        }}
        maxWIdth="md"
      >
        <SearchUser
          salesUser="true"
          onSelectUser={(user) => {
            setFieldValue("salesID", user.ID);
            setFieldValue("salesName", user.firstName + " " + user.lastName);
            setOpenSearchSales(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchSales(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchCashAccount}
        title="Search GL Account"
        onCloseDialog={() => {
          setOpenSearchCashAccount(false);
        }}
        maxWIdth="md"
      >
        <SearchGlAccount
          accountTypeID={1}
          onSelectGlAccount={(glAccount) => {
            setFieldValue("cashAccountID", glAccount.ID);
            setFieldValue("cashAccountName", glAccount.accountName);
            setOpenSearchCashAccount(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchCashAccount(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );

  function calculateDPamount(value, type = "percent") {
    let dpPercent = 0;
    let dpAmount = 0;
    if (type === "percent") {
      dpAmount = amountByPercent(
        parseFloat(value),
        parseFloat(values.grandTotal)
      );
      setFieldValue("dpAmount", dpAmount);
    } else if (type === "amount") {
      dpPercent = percentByAmount(
        parseFloat(value),
        parseFloat(values.grandTotal)
      );
      setFieldValue("dpPercent", dpPercent);
    }
  }

  function handleChangeCustomerType() {
    setFieldValue("customerID", 0);
    setFieldValue("customerName", "");
    setFieldValue("leadID", 0);
    setFieldValue("leadName", "");
    onSetCustomerAddresses([]);
    onSetCustomerContacts([]);
  }

  function handleCustomerAddressDefault() {
    setCustomerAddressDefault(false);
  }

  function handleCustomerContactDefault() {
    setCustomerContactDefault(false);
  }

  function handleCustomerTOCDefault() {
    setCustomerTOCDefault(false);
  }
}

export default QuotationHeader;
